/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography, Badge, Box } from '@mui/material';
import FxCard from '../../../../Container/FxCard';
import FxCardHeader from '../../../../Container/FxCardHeader';
import FxCardBody from '../../../../Container/FxCardBody';
import { ReactComponent as Verified } from '../../../../../assets/svg/verify-filled-icon.svg';
import { useMediaQuery } from 'react-responsive';
import FxCardFooter from '../../../../Container/FxCardFooter';
import { ReactComponent as ShieldSignupLeftpanel } from '../../../../../assets/svg/signup/shield-signup-leftpanel.svg';
import { checkMenuValid } from '../../Common/CommonSignupClass';
import { useIsMobileOrTabletScreen } from '../../../../../libs/utils/utils';


/**
 * Author : Shivaraj PP
 * Component: JointTenancyCoOwnerSignUpLeftBar
 * Description: Left bar for Joint Tenancy Co-Owner Sign Up
 */

export const JointTenancyCoOwnerSignUpLeftBar: React.FC<any> = React.memo((props) => {
  const isSmallScreen = useIsMobileOrTabletScreen();
  let keys = ['jtIdentificationForm', 'jtCoOwnerForm']
  // menu options
  const options: any = [];
  options.push({ title: "Review & Submit for Verification", action: "review_and_submit", subtitle: "Double-check your details and submit to complete your account setup.", order: 1 })


  return (
    <>
      {!isSmallScreen ?
        <Grid id="login-promo-Home-Grid" item xs={12} >
          <FxCard id="login-promo-Home-Card" className="fx-login-promo fx-login-promo-width-and-bg">
            <FxCardHeader className='fx-login-promo-header-card'>
              <Grid container direction="row" justifyContent="space-between" >
                <Grid item xs={10}>
                  <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
                    Welcome!
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
                    Let's set up your Passport Account
                  </Typography>
                </Grid>
              </Grid>
            </FxCardHeader>
            <FxCardBody id="login-promo-Home-Card-Body" >
              <Grid item container xs={12} className='fx-signup-stage'>
                {options.map((link: any, index: any) => {
                  return (
                    <Grid item xs={12}>
                      <ul id={'login-promo-icon-' + link.action}  >
                        <li className={props.activeMenu === link.order ? 'fx-signup-stage-selected-theme-color' : ''}>
                          <Grid item container alignItems="center" xs={12}>
                            <Grid item>
                              <Badge badgeContent={index + 1} >
                                <Box className='fx-signup-stage-icon'>{checkMenuValid(link, keys[index], props.activeMenu)}</Box>
                              </Badge>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="h4"
                                className="fx-list-item-maintitle"
                              >
                                {link.title}
                              </Typography>
                              {link.subtitle && (
                                <Typography variant="body2" className="fx-list-item-subtitle">
                                  {link.subtitle}
                                </Typography>
                              )}
                            </Grid>
                            <ul>
                              {link.childOptions?.map((childLink: any) => {
                                return <li><Typography variant="h6" className={props.activeMenu === link.order ? 'fx-selected-list' : ''}>{childLink.title}</Typography></li>
                              })}
                            </ul>
                          </Grid>
                        </li>

                      </ul>
                    </Grid>
                  )
                })}
              </Grid>
            </FxCardBody>
            <FxCardFooter>
              <Grid xs={12} columnSpacing={2}>
                <div className="left-panel-privacy left-panel-privacy-individual">
                  <ShieldSignupLeftpanel />
                  <p>Your privacy matters to us. Your information is securely stored and encrypted.</p>
                </div>
              </Grid>
            </FxCardFooter>
          </FxCard>
        </Grid>
        :
        <Grid id="login-promo-Home-Grid" item xs={12} >
          <FxCard id="login-promo-Home-Card" className="fx-login-promo fx-login-promo-topmenu-mobile">
            <FxCardBody id="login-promo-Home-Card-Body" >
              <Grid item container xs={12} className='fx-signup-stage fx-signup-stage-mobile '>
                {options.map((link: any, index: any) => {
                  return (
                    <ul id={'login-promo-icon-' + link.action} className='fx-login-promo-list-box' >
                      <li className={props.activeMenu === link.order ? 'fx-signup-stage-selected ' : ''}>
                        <Grid item container alignItems="center" xs={12}> <Grid item className='fx-login-promo-list-box-item'>
                          <Badge badgeContent={index + 1} >
                            <Box className='fx-signup-stage-icon'> {(((props?.activeMenu === 1) && (link.title !== "Account Identifier" && link.title !== "Account Identifier" && link.title !== 'Review & Submit for Verification')) || ((props?.activeMenu === 2) && (link.title !== 'Review & Submit for Verification'))) && <Verified />}</Box>
                          </Badge>
                        </Grid><Grid item xs><Typography variant="h5">
                          {link.title}</Typography></Grid>
                          <ul>
                            {link.childOptions?.map((childLink: any) => {
                              return <li><Typography variant="h6" className={props.activeMenu === link.order ? 'fx-selected-list' : ''}>{childLink.title}</Typography></li>
                            })}
                          </ul>
                        </Grid>
                      </li>

                    </ul>
                  )
                })}
              </Grid>
            </FxCardBody>
          </FxCard>
        </Grid>

      }
    </>
  )
})